<template>
  <v-container fluid class="login-page">
    <v-layout row wrap justify-content-center align-content-center>
      <v-flex xs12 sm8 md6 mx-auto>
        <v-card class="card-form mx-auto">
          <icon name="logo" />
          <form @submit.prevent="login">
            <v-alert v-if="errorMessage" :value="true" type="error" outline class="mb-2">{{ errorMessage }}</v-alert>
            <v-layout column>
              <v-flex>
                <v-text-field type="text" :label="$gettext('Username')" v-model="input.username"></v-text-field>
              </v-flex>
              <v-flex>
                <v-text-field type="password" :label="$gettext('Password')"  v-model="input.password"></v-text-field>
              </v-flex>
              <v-flex class="text-xs-center" mt-2>
                <v-btn type="submit" color="primary" large><span v-translate>Sign In</span></v-btn>
              </v-flex>
            </v-layout>
          </form>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from 'vuex';
import { LOGIN } from '@/store/action-types';

export default {
  name: 'Login',
  data() {
    return {
      input: {
        username: '',
        password: '',
      },
      errorMessage: '',
    };
  },
  computed: {
    ...mapState({
      token: state => state.auth.token,
    }),
  },
  methods: {
    login() {
      if (this.input.username !== '' && this.input.password !== '') {
        this.$store.dispatch(LOGIN, this.input);
      } else {
        this.errorMessage = this.$gettext('A username and password must be present');
      }
    },
  },
  mounted() {
    if (this.token !== '') {
      const visibleMenu = this.$store.getters.getVisibleMenu(this.can);
      if(visibleMenu.length == 0) return;
      let firstLink = visibleMenu[0];
      if(firstLink.route) {
        this.$router.replace({ name: firstLink.route });
      } else if(firstLink.children) {
        this.$router.replace({ name: firstLink.children[0].route });
      }
      
    }
  },
};
</script>
